import { useNavigate, useParams } from 'react-router-dom';
import { useDistrict } from '../district';
import { RecoveryRecoverModal } from './RecoveryRecoverModal';

/**
 * U2 ユーザー復帰コードで復帰 (EntryPage の「以前参加したことがある」導線、`/m/:urlToken/recovery/recover`)。
 *
 * old2 は専用 page だったが、v2 では復帰 UI を `RecoveryRecoverModal` (12 文字入力 + 正規化 +
 * recoverParticipant callable) に集約済のため、本 page はそれを open 固定で全画面ラップする薄い
 * 繋ぎとする (暫定 page)。
 *   - 復帰成功 → map へ navigate replace
 *   - 閉じる (キャンセル) → EntryPage (`/m/:urlToken`) に戻る
 */
export function RecoveryRecoverPage() {
  const navigate = useNavigate();
  const { urlToken } = useParams();
  const district = useDistrict();

  return (
    <main className="mx-auto max-w-md p-6">
      <RecoveryRecoverModal
        open
        districtName={district?.name ?? ''}
        districtToken={urlToken}
        onClose={() => navigate(`/m/${urlToken}`)}
        onFallback={() => navigate(`/m/${urlToken}/onboarding`)}
        onRecovered={() => navigate(`/m/${urlToken}/map`, { replace: true })}
      />
    </main>
  );
}
